const paymentVjiHost = process.env.PAYMENT_VJI_HOST;

export default paymentVjiHost;
